import * as ng from 'angular';
import { ArchiSmallServices } from '../../../services/archismall.service';

class ConfermaEliminaDocConservazioneController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    'ArchiSmallServices',
    '$timeout',
    '$uibModalStack',
    '$state'
  ];

  private close: any;
  private dismiss: any;

  constructor(
    private $scope: any,
    private $rootScope: any,
    private ArchiSmallServices: ArchiSmallServices,
    private $timeout: ng.ITimeoutService,
    private $modalStack: ng.ui.bootstrap.IModalStackService,
    private $state: any
  ) {

    $scope.ok = () => {
      this.close({$value: true});
    };
    $scope.annulla = () => {
      this.close({$value: false});
    };
  }
}

export const ConfermaEliminaDocConservazioneComponent: ng.IComponentOptions = {
  template: require('./conferma-elimina-doc-conservazione.html'),
  controller: ConfermaEliminaDocConservazioneController,
  bindings: {
    close: '&',
    dismiss: '&'
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/conferma-elimina-doc-conservazione/conferma-elimina-doc-conservazione.ts